import { BasePartParameterValue } from '../schemas/BasePartParameterValue';
import { DisplayName } from '../schemas/DisplayName';

export const convertToCSV = (data: BasePartParameterValue[], language: string): string => {
    const csvRows: string[] = [];

    // 輔助函數：根據語言獲取顯示名稱
    const getDisplayNameByLanguage = (
        displayNames: DisplayName[] | undefined | null,
        defaultValue: string
    ): string => {
        if (!displayNames || displayNames.length === 0) return defaultValue;
        const displayName = displayNames.find((dn) => dn.language === language);
        return displayName ? displayName.display : defaultValue;
    };

    // 只保留 basePn
    const baseHeaders = ['basePn'];

    // 建立參數名稱到顯示名稱的映射
    const parameterMap = new Map<string, string>();
    // 收集所有可能的參數名稱
    const parameterNames = new Set<string>();

    data.forEach((item) => {
        item.parameterValues.forEach((param) => {
            const displayName = getDisplayNameByLanguage(
                param.parameterDisplayNames,
                param.parameterName
            );
            parameterMap.set(param.parameterName, displayName);
            parameterNames.add(param.parameterName);
        });
    });

    // 組合完整的 headers
    const headers = [
        ...baseHeaders,
        ...Array.from(parameterNames).map((name) => parameterMap.get(name) || name),
    ];
    csvRows.push(headers.join(','));

    // 填充數據
    data.forEach((item) => {
        const row: Record<string, string> = {};

        // 填充基本欄位
        // row['basePartId'] = item.basePartId.toString();
        row['basePn'] = item.basePn;
        // row['manufacturer'] = item.manufacturer || '';
        // row['dataSheet'] = item.dataSheet || '';
        // row['imagePath'] = item.imagePath || '';
        // row['ksimSupport'] = String(item.ksimSupport || false);
        // row['rohs'] = String(item.rohs);
        // row['specsheetSuppression'] = String(item.specsheetSuppression || false);
        // row['step'] = item.step || '';

        // 填充參數值
        item.parameterValues.forEach((param) => {
            const originalName = param.parameterName;
            const displayName = parameterMap.get(originalName) || originalName;
            row[displayName] = param.formattedValue || param.value;
        });

        // 按照 header 順序輸出並處理轉義
        const values = headers.map((header) => {
            const value = row[header] || '';
            const escaped = value.replace(/"/g, '""');
            return `"${escaped}"`;
        });

        csvRows.push(values.join(','));
    });

    return csvRows.join('\n');
};

export const downloadCSV = (csv: string, filename: string): void => {
    const BOM = '\uFEFF'; // 添加 BOM 以支持中文
    const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
